import { writable} from 'svelte/store';
import tailwindTheme from 'tailwindcss/defaultTheme';
import Robot from './Robot';
import Vector2 from './Vector2';
import Command from './Command';

export const colors = writable(tailwindTheme.colors);
export const player = writable(new Robot());
export const enemies = writable([
    new Robot(new Vector2(2, 2), Command.randomCommands(5), [{x: 0, y: 0, width: 1, height: .3}]),
    new Robot(new Vector2(3, 3), Command.randomCommands(5), [{x: 0, y: .3, width: 1, height: .4}]),
    new Robot(new Vector2(4, 4), Command.randomCommands(5), [{x: 0, y: .7, width: 1, height: .3}]),
]);

export const gridSize = 8;

export const load = store => {
    let value;
    const unsubscribe = store.subscribe(storeValue => {
        value = storeValue;
    });
    unsubscribe();
    return value;
}
